import React              from 'react'
import VisPercent         from './statistics/VisPercent'
import TeamCompareHeader  from './statistics/TeamCompareHeader'
import StatsTable         from './statistics/StatsTable'
import AnchorLink         from '../../../common/AnchorLink'

const MatchStats = ({
  title   = '',
  dataVis = [],
  home    = {},
  away    = {},
  table   = {},
  link    = {}, 
  sport   = 'rugby'
}) => {
  
  let sClass = 'sub-module ' + sport
  if ( sport == 'rugby' ) {
    sClass += ' match-stats'
  }
    
  return (
    <div className={sClass}>
      <header className="bordered">
        <h1>{title}</h1>
      </header>
      <div className="content" style={ { overflow: 'auto' } }>
        { 
          sport == 'rugby' &&
          <div className="data-vis">
            <TeamCompareHeader heading={dataVis[0].text} home={home} away={away} />
            <VisPercent homeColor={home.color} awayColor={away.color} {...dataVis[0]} />
            <TeamCompareHeader heading={dataVis[1].text} noTeams={'no-teams'} />
            <VisPercent large={true} homeColor={home.color} awayColor={away.color} {...dataVis[1]} />
          </div>
        }
        <div className="stat-list">
          <TeamCompareHeader bordered={true} home={home} away={away} />
          <StatsTable stats={table} />
        </div>        
      </div>
      <footer>
        <AnchorLink {...link}/>
      </footer>
    </div>
  )
}

export default MatchStats



/** WEBPACK FOOTER **
 ** ../app/components/gamepackage/rugby/components/MatchStats.jsx
 **/